export default __webpack_public_path__ + "static/media/dishplaceholder.91ea4630.png";